import BaseRepository from '@/repositories/base/BaseRepository';

class ChengStarSalesDistributionService extends BaseRepository {
  // 红包延期
  redPacketDelay(tradeSerialId: string) {
    return this.post<any>({
      url: '/ebk-dkb-api/cheng-star-sales-distribution/red-packet-delay',
      data: { tradeSerialId },
    });
  }
}

export default ChengStarSalesDistributionService;
